import { Box, Typography } from '@mui/material';
import { toolTipStyles } from 'components/common/Tooltip';
import { ChartDataPointWithDateRange } from 'features/socialMediaListening/hooks/useGraphDataMakerNew';
import { BrandMetricsFilters } from 'graphql/generated';
import { useGuardNavigate } from 'hooks/navigation/useGuardNavigation';
import moment from 'moment';
import { InteractionSearchParams } from 'pages/socialMediaListening/analytics/outbound/interaction/types';
import { Location, useLocation } from 'react-router-dom';
import { TooltipProps } from 'recharts';
import {
  NameType,
  ValueType,
} from 'recharts/types/component/DefaultTooltipContent';
import { PlotRoutes } from 'Routes';
import { theme } from 'styles/theme';

export type MetricsChartCustomTooltipProps = TooltipProps<
  ValueType,
  NameType
> & {
  brandId: string;
  filters: BrandMetricsFilters;
};

export const MetricsChartCustomTooltip = ({
  brandId,
  active,
  payload,
  label,
  filters,
}: MetricsChartCustomTooltipProps) => {
  const location = useLocation();
  const { backgroundLocation } = (location.state || {}) as {
    backgroundLocation?: Location;
  };
  const navigate = useGuardNavigate();

  if (active && payload && payload.length) {
    return (
      <Box
        sx={{
          ...toolTipStyles,
          display: 'flex',
          flexDirection: 'column',
          gap: theme.spacing(2),
          pointerEvents: 'auto',
          cursor: 'pointer',
        }}
        onClick={() => {
          const dateRange = payload[0]?.payload as ChartDataPointWithDateRange;
          const startDate = dateRange.dateRange[0];
          const endDate = dateRange.dateRange[1];

          // check if startDate and endDate are valid dates
          const parsedStartDate = moment(startDate).isValid()
            ? moment(startDate).toISOString()
            : undefined;
          const parsedEndDate = moment(endDate).isValid()
            ? moment(endDate).toISOString()
            : undefined;

          // when user clicks on the tooltip => navigate to the outbound interactions page with the selected filters
          const searchFilters: InteractionSearchParams = {
            platforms: filters.platforms || undefined,
            creatorIds: filters.creatorIds || undefined,
            startDate: parsedStartDate,
            endDate: parsedEndDate,
            sources: filters.sources || undefined,
            topicIds: filters.topicIds || undefined,
            responderIds: filters.responderIds || undefined,
          };

          navigate(
            PlotRoutes.socialListeningAnalyticsOutboundInteractions(
              brandId,
              searchFilters,
            ),
            { state: { backgroundLocation: backgroundLocation || location } },
          );
        }}
      >
        <Typography variant="subhead-sm">{label}</Typography>
        <Typography variant="headline-sm">{`${payload[0].value} interactions`}</Typography>
      </Box>
    );
  }

  return null;
};
